/* import __COLOCATED_TEMPLATE__ from './track-conversation-resumed.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Conversation from 'embercom/objects/inbox/conversation';
import type ConversationResumeService from 'embercom/services/conversation-resume-service';
import type Router from '@ember/routing/router-service';

interface Args {
  conversation: Conversation;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class TrackConversationResumed extends Component<Signature> {
  @service declare conversationResumeService: ConversationResumeService;
  @service declare router: Router;

  private lastCheckedConversationId: number | null = null;

  get isConversationValid(): boolean {
    return (
      !this.args.conversation.isBackOfficeTicket &&
      !this.args.conversation.isSideConversation &&
      !this.args.conversation.isTrackerTicket &&
      !this.args.conversation.isLoading
    );
  }

  get isRouteValid(): boolean {
    // We only want to track conversation resumption on the inbox routes
    return this.router.currentRouteName.includes('inbox.workspace.inbox');
  }

  @action
  handleConversationResumption() {
    this.conversationResumeService.handleResumption(this.args.conversation);
    this.lastCheckedConversationId = this.args.conversation.id;
  }

  @action
  onUpdateConversation(_element: Element, [conversationId]: [number]) {
    if (this.lastCheckedConversationId === conversationId) {
      return;
    }

    this.handleConversationResumption();
  }

  @action
  onConversationUpdated() {
    // Add a resume event whenever a teammate is viewing an open & assigned conversation
    this.conversationResumeService.handleResumption(this.args.conversation);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Conversation::TrackConversationResumed': typeof TrackConversationResumed;
    'inbox2/conversation/track-conversation-resumed': typeof TrackConversationResumed;
  }
}
